<template>
  <section class="contacts-section">
    <Toolbar title-tag="h1">
      <template #title>Контакты</template>
    </Toolbar>
    <ContentBlock class="contacts-section__card" paddings>
      <dl class="contacts-section__dl">
        <InfoItem title="E-mail">
          <a href="mailto:Shlemikragi@mail.ru">Shlemikragi@mail.ru</a>
        </InfoItem>
      </dl>
      <dl class="contacts-section__dl">
        <InfoItem title="Места проведения по городам">
          <p>
            <b>г. Москва</b>&nbsp;&mdash; СК «Искра» - Сельскохозяйственная ул.,
            26, стр. 2
          </p>
          <!-- <p><b>г. Воронеж</b>&nbsp;&mdash; Площадь Ленина</p> -->
          <p>
            <b>г. Санкт-Петербург</b>&nbsp;&mdash; Стадион им. Б.А. Шилова - ул.
            Демьяна Бедного, 19, корп. 2
          </p>
          <p>
            <b>г. Казань</b>&nbsp;&mdash; Стадион «Трудовые резервы» - ул.
            Николая Ершова, 7А
          </p>
          <p>
            <b>г. Екатеринбург</b>&nbsp;&mdash; Стадион "Юноость" - ул.
            Куйбышева, 32А, корп. 3
          </p>
          <!-- <p><b>г. Новосибирск</b>&nbsp;&mdash; Залесского 3, Стадион СГУПС</p> -->
          <!-- <p><b>г. Владимир</b>&nbsp;&mdash; ЦПКиО, каток «Ералаш»</p> -->
          <!-- <p>
            <b>г. Пермь</b>&nbsp;&mdash; Стадион "Юность" - ул. Революции, 27
          </p>
          <p><b>г. Магнитогорск</b>&nbsp;&mdash; ул. Лесопарковая, 1/2</p> -->
        </InfoItem>
      </dl>

      <!-- <iframe
        src="https://yandex.ru/map-widget/v1/?um=constructor%3A73830b1db5351af53cea16bc87f7d73bb433e581f1fc6349affd4ed91a8b795d&amp;source=constructor"
        width="100%"
        height="450"
        frameborder="0"
        class="contacts-section__map"
      ></iframe> -->
    </ContentBlock>
  </section>
</template>

<script>
import Toolbar from "@/components/ui/toolbar/Toolbar";
import ContactsSectionInfoItem from "./ContactsSectionInfoItem";

export default {
  name: "ContactsSection",
  components: {
    Toolbar,
    InfoItem: ContactsSectionInfoItem
  }
};
</script>

<style lang="scss">
.contacts-section {
  &__dl {
    margin-bottom: 20px;
    display: flex;
  }

  @include breakpoint("md-and-down") {
    &__dl {
      flex-direction: column;
    }
  }
}
</style>
